import { render } from "./GTProjectList.vue?vue&type=template&id=5e28eed2&scoped=true"
import script from "./GTProjectList.vue?vue&type=script&lang=js"
export * from "./GTProjectList.vue?vue&type=script&lang=js"

import "./GTProjectList.vue?vue&type=style&index=0&id=5e28eed2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e28eed2"

export default script